module.exports = "/_next/static/images/6eebcdd3ab01c882a4ee7e64c6af54a9-roxinho-basicos-flutuantes-lg@3x.png.webp";